import { Select as AntdSelect } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import { BaseSelectProps } from "./Select.types";
import "./Select.scss";

export const Select = <T = any,>({
  size = "lg",
  error = false,
  className = "",
  suffixIcon,
  disabled,
  ...props
}: BaseSelectProps<T>) => {
  const selectClass = [
    "base-select",
    `base-select--${size}`,
    error && "base-select--error",
    disabled && "base-select--disabled",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  const defaultSuffixIcon = suffixIcon || (
    <CaretDownOutlined style={{ fontSize: "1rem", color: "#6D7693" }} />
  );

  return (
    <AntdSelect
      className={selectClass}
      suffixIcon={defaultSuffixIcon}
      disabled={disabled}
      {...props}
    />
  );
};

Select.Option = AntdSelect.Option;
Select.OptGroup = AntdSelect.OptGroup;

export default Select;
